import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { registerServiceWorker } from './lib/pwa';
registerServiceWorker();
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
